enum OnboardingStatus {
  pass = 'pass',
  fail = 'fail',
  pending = 'pending',
  incomplete = 'incomplete',
  none = 'none',
  error = 'error',
}

export default OnboardingStatus;
